import { createTRPCClient, httpLink } from "@trpc/client";
import type { AppRouter } from "@/backend/@router/appTrpc"; // Adjust path based on your project structure
import { getApiBaseUrl } from "@/frontend/config";
import { getOidcUser, refreshToken } from "@/frontend/user/userManager";

export const client = createTRPCClient<AppRouter>({
    links: [
        httpLink({
            url: `${getApiBaseUrl()}/trpc`,
            async fetch(url, options) {
                // logic copied from apiCall in apiBase.ts

                // if token is expired, refresh it before making api call
                const user = getOidcUser();
                if (user?.expires_at && user.expires_at < Date.now() / 1000) {
                    await refreshToken();
                }

                let response: Response | undefined;
                response = await apiFetch(
                    url,
                    options as { headers?: Record<string, string> }
                );

                if (isTokenError(response)) {
                    // refresh token
                    await refreshToken();
                    // retry the original call
                    response = await apiFetch(
                        url,
                        options as { headers?: Record<string, string> }
                    );
                }

                return response;
            }
        })
    ]
});

function isTokenError(response: Response) {
    return !response.ok && response.status === 401;
}

function apiFetch(
    url: URL | RequestInfo,
    options: { headers?: Record<string, string> } | undefined
) {
    const token = getOidcUser()?.id_token;

    if (token) {
        options ??= {};
        options.headers ??= {};
        if (typeof options.headers === "object") {
            options.headers["Authorization"] = `Bearer ${token}`;
        }
    }

    return fetch(url, options);
}
